import React from 'react';
import { useReactToPrint } from 'react-to-print';
import { useState, useRef } from 'react';
import { Typography, Box, Button } from '@mui/material';
import { List, ListItem, ListItemText, Divider, Grid } from '@mui/material';
import { makeStyles } from '@mui/styles'
import HeightBox from '../components/HeightBox';
import image from '../images/recruit-logo.png'
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import "react-pdf/dist/esm/Page/TextLayer.css";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    margin: "auto",
    // padding: "2rem",
  },
  header: {
    marginBottom: "1rem",
  },
  sectionHeader: {
    marginTop: "2rem",
    marginBottom: "1rem",
  },
  listItemText: {
    margin: "0",
  },
  textContent: {
    display: 'none',
  },

  // Add print styles here
  '@media print': {
    header: {
      position: 'fixed', // 'fixed
      top: 0,
      width: '100%',
      zIndex: 100,
      justifyContent: 'space-between',
    },
    body: {
      marginTop: '150px', // adjust the top margin to account for the fixed header
    },
    '.page': {
      pageBreakAfter: 'fixed',

    },
  },
}));

const cv = {
  basicInfo: {
    name: "John Doe",
    email: "ffksdks@gmail.com",
    phone: "1234567890",
    address: "123, abc street, xyz city, 12345",
    linkedin: "linkedin.com/in/johndoe",
    github: "github.com/johndoe",
    website: "johndoe.com",
  },
  educationalQualification: {
    1: {
      title: "Educational Qualification",
      description: "fajfkldfsdlfsdfdsf",
      year: "2019",
    },
    2: {
      title: "Educational Qualification",
      description: "fajfkldfsdlfsdfdsf",
      year: "2019",
    },
  },
  professionalQualifications: {
    1: {
      title: "Professional Qualitifcation",
      description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed euismod, diam id aliquam ultrices, nisl nunc aliquet enim, vitae aliquam nunc nisl vitae nunc. Sed euismod, diam id aliquam ultrices, nisl nunc aliquet enim, vitae aliquam nunc nisl vitae nunc.",
      yearfrom: "2019",
      yearto: "2020",
    },
    2: {
      title: "Professional Qualitifcation",
      description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed euismod, diam id aliquam ultrices, nisl nunc aliquet enim, vitae aliquam nunc nisl vitae nunc. Sed euismod, diam id aliquam ultrices, nisl nunc aliquet enim, vitae aliquam nunc nisl vitae nunc.",
      yearfrom: "2019",
      yearto: "2020",
    },

  },
  workExperience: {
    1: {
      title: "Work Experience",
      description: "fjdfkdfjksdfdf",
      yearfrom: "2019",
      yearto: "2020",
    },
    2: {
      title: "Work Experience",
      description: "fjdfkdfjksdfdf",
      yearfrom: "2019",
      yearto: "2020",
    },
  },
}

const UserProfileContainer = () => {
  // Dummy data for the table
  const [cvData, setCvData] = React.useState(cv);
  const [personalInfo, setPersonalInfo] = React.useState(
    {
      "fullName": "GUNASINGHE ARACHCHILAGE DINUSHA SADEEP RUKSHAN",
      "dob": "01ST OF DECEMBER 1995",
      "age": "27 YEARS",
      "nationality": "SRI LANKA",
      "gender": "MALE",
      "civilStatus": "SINGLE",
      "availability": "IMMEDIATE"
    });
  const [professionalQualifications, setProfessionalQualifications] = React.useState([
    {
      id: 1,
      title: "Professional Qualification 1",
      description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed euismod, diam id aliquam ultrices, nisl nunc aliquet enim, vitae aliquam nunc nisl vitae nunc.",
      yearfrom: "2019",
      yearto: "2020",
    },
    {
      id: 2,
      title: "Professional Qualification 2",
      description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed euismod, diam id aliquam ultrices, nisl nunc aliquet enim, vitae aliquam nunc nisl vitae nunc.",
      yearfrom: "2019",
      yearto: "2020",
    },
    {
      id: 3,
      title: "Professional Qualification 3",
      description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed euismod, diam id aliquam ultrices, nisl nunc aliquet enim, vitae aliquam nunc nisl vitae nunc.",
      yearfrom: "2019",
      yearto: "2020",
    },
    {
      id: 4,
      title: "Professional Qualification 4",
      description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed euismod, diam id aliquam ultrices, nisl nunc aliquet enim, vitae aliquam nunc nisl vitae nunc.",
      yearfrom: "2019",
      yearto: "2020",
    },
    {
      id: 5,
      title: "Professional Qualification 5",
      description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed euismod, diam id aliquam ultrices, nisl nunc aliquet enim, vitae aliquam nunc nisl vitae nunc.",
      yearfrom: "2019",
      yearto: "2020",
    },
    {
      id: 6,
      title: "Professional Qualification 6",
      description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed euismod, diam id aliquam ultrices, nisl nunc aliquet enim, vitae aliquam nunc nisl vitae nunc.",
      yearfrom: "2019",
      yearto: "2020",
    },

  ]);
  const [workExperience, setWorkExperience] = React.useState([
    {
      id: 1,
      title: "Work Experience 1",
      description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed euismod, diam id aliquam ultrices, nisl nunc aliquet enim, vitae aliquam nunc nisl vitae nunc.",
      yearfrom: "2019",
      yearto: "2020",
    }
  ]);
  const [educationalQualification, setEducationalQualification] = React.useState([
    {
      id: 1,
      title: "Educational Qualification 1",
      description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed euismod, diam id aliquam ultrices, nisl nunc aliquet enim, vitae aliquam nunc nisl vitae nunc.",
      year: "2019",
    }
  ]);
  const [Skills, setSkills] = React.useState([
    {
      id: 1,
      title: "Skill 1",
      description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed euismod, diam id aliquam ultrices, nisl nunc aliquet enim.",
    }
  ]);


  const data = [
    { id: 1, name: 'John Doe', age: 25 },
    { id: 2, name: 'Jane Smith', age: 30 },
    { id: 3, name: 'Mike Johnson', age: 35 },
    { id: 3, name: 'Mike Johnson', age: 35 },
    { id: 3, name: 'Mike Johnson', age: 35 },
    { id: 3, name: 'Mike Johnson', age: 35 },
    { id: 3, name: 'Mike Johnson', age: 35 },
    { id: 3, name: 'Mike Johnson', age: 35 },
    { id: 3, name: 'Mike Johnson', age: 35 },
    { id: 3, name: 'Mike Johnson', age: 35 },
    { id: 3, name: 'Mike Johnson', age: 35 },
    { id: 3, name: 'Mike Johnson', age: 35 },
    { id: 3, name: 'Mike Johnson', age: 35 },
    { id: 3, name: 'Mike Johnson', age: 35 },
    { id: 3, name: 'Mike Johnson', age: 35 },
    { id: 3, name: 'Mike Johnson', age: 35 },
    { id: 3, name: 'Mike Johnson', age: 35 },
    { id: 3, name: 'Mike Johnson', age: 35 },
    { id: 3, name: 'Mike Johnson', age: 35 },
    { id: 3, name: 'Mike Johnson', age: 35 },
    { id: 3, name: 'Mike Johnson', age: 35 },
    { id: 3, name: 'Mike Johnson', age: 35 },
  ];

  const classes = useStyles();
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const [selectedFile, setSelectedFile] = useState(null);
  const [numPages, setNumPages] = useState(null);
  const [jpgImages, setJpgImages] = useState([]); // array of base64 strings
  const [renderTextLayer, setRenderTextLayer] = useState(false);

  const toggleTextLayer = () => {
    setRenderTextLayer(!renderTextLayer);
  };

  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  const [containerWidth, setContainerWidth] = useState(null);


  React.useEffect(() => {
    if (componentRef.current) {
      const width = componentRef.current.offsetWidth;
      setContainerWidth(width);
    }
  }, []);

  const convertToJpg = () => {
    if (selectedFile) {
      const jpgPromises = Array.from({ length: numPages }, (_, index) => {
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');

        return new Promise((resolve) => {
          const image = new Image();
          image.src = canvas.toDataURL('image/jpeg');
          console.log(image.src)
          image.onload = () => {
            context.clearRect(0, 0, canvas.width, canvas.height);
            canvas.width = image.width;
            canvas.height = image.height;
            context.drawImage(image, 0, 0);

            canvas.toBlob((blob) => {
              resolve(blob);
            }, 'image/jpeg');
          };
        });
      });

      Promise.all(jpgPromises)
        .then((jpgBlobs) => {
          const jpgUrls = jpgBlobs.map((blob) => URL.createObjectURL(blob));
          console.log(jpgUrls);
          setJpgImages(jpgUrls);
        })
        .catch((error) => {
          console.error('Error converting to JPG:', error);
        });
    }
  };


  return (
    <>
      <Button onClick={handlePrint}>Print this out!</Button>
      <style type="text/css" media="print">
        {"\
          @page { size: portrait;   border: 2px solid black; margin: 20px          }\
        "}
      </style>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <input type="file" accept="application/pdf" onChange={handleFileChange} />
        </Grid>
        <Grid item xs={12}>
          <Button variant="contained" color="primary" disabled={!selectedFile} onClick={convertToJpg}>
            Convert to JPG
          </Button>
        </Grid>
        {selectedFile && (
          <Grid item xs={12}>
            <Typography>{`Selected file: ${selectedFile.name}`}</Typography>
          </Grid>
        )}
      </Grid>
      <div ref={componentRef}>

        <table style={{ width: '100%', maxWidth: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr>
              <th colSpan={3}>
                <Box
                  display='flex'
                  justifyContent='space-between'
                  alignItems='right'
                  sx={{ backgroundColor: '#f5f5f7', padding: '10px', opacity: 1 }}
                >

                  <Box>
                    <Typography variant='h5' gutterBottom>
                      <img src={image} alt='Company Logo' style={{ height: '150px', marginRight: '16px' }} />
                    </Typography>
                    <Typography variant='subtitle1' gutterBottom>
                    </Typography>
                  </Box>
                  <Box display='flex' alignItems='right'>
                    {/* <img src='/images/log.png' alt='Company Logo' style={{ height: '50px', marginRight: '16px' }} /> */}
                    <Box textAlign='right'>
                      <Typography variant='subtitle1' gutterBottom>
                        RECRUITS PLUS (PVT) LTD.
                      </Typography>
                      <Typography variant='subtitle2' gutterBottom>
                        Address: No.462/D, 02nd Floor, Arangala Junction, Athurugiriya Road, Malambe, Sri Lanka.
                      </Typography>
                      <Typography variant='subtitle2' gutterBottom>
                        Hotline: +94 77 687 1847 / +94 77 757 0707 / +94 11 286 0310
                      </Typography>
                      <Typography variant='subtitle2' gutterBottom>
                        Email: cv@recruitsplus.org / malinda@recruitsplus.org
                      </Typography>
                      <Typography variant='subtitle2' gutterBottom>
                        Website: www.recruitsplus.org
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </th>
            </tr>

          </thead>
          {/* Personal Information */}

          <tbody>
            <td>
              <HeightBox height={20} />

              <Box sx={{ fontSize: '16px', fontFamily: 'Arial, sans-serif' }}>
                <Box
                  display='flex'
                  justifyContent='space-between'
                  alignItems='right'
                  sx={{ backgroundColor: '#07519d ', color: 'white', padding: '10px', opacity: 1 }}
                >
                  <Typography variant='h6' gutterBottom>
                    Personal Information
                  </Typography>
                </Box>
                <HeightBox height={10} />


                <Box display='flex' flexDirection='row'>
                  <Box mr={2}>
                    <img style={{ maxWidth: '200px' }} src='https://picsum.photos/400' alt="Hi" />
                  </Box>
                  <Box>
                    <Typography variant='body1' gutterBottom>
                      FULL NAME: {personalInfo?.fullName}
                    </Typography>
                    <Typography variant='body1' gutterBottom>
                      DATE OF BIRTH: {personalInfo?.dob}
                    </Typography>
                    <Typography variant='body1' gutterBottom>
                      AGE: {personalInfo?.age}
                    </Typography>
                    <Typography variant='body1' gutterBottom>
                      NATIONALITY: {personalInfo?.nationality}
                    </Typography>
                    <Typography variant='body1' gutterBottom>
                      GENDER: {personalInfo?.gender}
                    </Typography>
                    <Typography variant='body1' gutterBottom>
                      CIVIL STATUS: {personalInfo?.civilStatus}
                    </Typography>
                    <Typography variant='body1' gutterBottom>
                      AVAILABILITY: {personalInfo?.availability}
                    </Typography>
                  </Box>
                </Box>

              </Box>
            </td>
          </tbody>

          {/* Skills */}
          <tbody>
            <td>
              <HeightBox height={20} />

              <Box sx={{ fontSize: '16px', fontFamily: 'Arial, sans-serif' }}>
                <Box
                  display='flex'
                  justifyContent='space-between'
                  alignItems='right'
                  sx={{ backgroundColor: '#07519d ', color: 'white', padding: '10px', opacity: 1 }}
                >
                  <Typography variant='h6' gutterBottom>
                    Skills
                  </Typography>
                </Box>
                <HeightBox height={10} />


                <Box display="flex" flexDirection="row">
                  <Box>
                    <td>
                      <List>
                        {Skills?.map((qualification) => (
                          <tbody>
                            <ListItem key={qualification.title}>
                              <ListItemText
                                primary={qualification.title}
                                secondary={qualification.description}
                                className={classes.listItemText}
                              />
                            </ListItem>
                          </tbody>
                        ))}
                      </List>
                    </td>
                  </Box>
                </Box>

              </Box>
            </td>
          </tbody>

          {/* Summary */}
          <tbody>
            <td>
              <HeightBox height={20} />

              <Box sx={{ fontSize: '16px', fontFamily: 'Arial, sans-serif' }}>
                <Box
                  display='flex'
                  justifyContent='space-between'
                  alignItems='right'
                  sx={{ backgroundColor: '#07519d ', color: 'white', padding: '10px', opacity: 1 }}
                >
                  <Typography variant='h6' gutterBottom>
                    Summary of Career
                  </Typography>
                </Box>
                <HeightBox height={10} />


                <Box display="flex" flexDirection="row">

                  <Box style={{ padding: 10 }}>
                    <Typography variant="body1" gutterBottom>
                      <Grid container spacing={2}>
                        <Grid item xs={6} sm={6}>
                          YEARS OF EXPERIENCE
                        </Grid>
                        <Grid item xs={6} sm={6}>
                          : GUNASINGHE ARACHCHILAGE DINUSHA SADEEP RUKSHAN.
                        </Grid>
                      </Grid>
                    </Typography>
                    <Typography variant="body1" gutterBottom>
                      <Grid container spacing={2}>
                        <Grid item xs={6} sm={6}>
                          PROFESSIONAL QUALIFICATION
                        </Grid>
                        <Grid item xs={6} sm={6}>
                          : 01ST OF DECEMBER 1995.
                        </Grid>
                      </Grid>
                    </Typography>
                    <Typography variant="body1" gutterBottom>
                      <Grid container spacing={2}>
                        <Grid item xs={6} sm={6}>
                          IT LITERACY
                        </Grid>
                        <Grid item xs={6} sm={6}></Grid>
                      </Grid>
                    </Typography>
                    <Typography variant="body1" gutterBottom>
                      <Grid container spacing={2}>
                        <Grid item xs={6} sm={6}>
                          CURRENT LOCATION
                        </Grid>
                        <Grid item xs={6} sm={6}>
                          : SRI LANKA.
                        </Grid>
                      </Grid>
                    </Typography>
                    <Typography variant="body1" gutterBottom>
                      <Grid container spacing={2}>
                        <Grid item xs={6} sm={6}>
                          CURRENT SALARY PACKAGE
                        </Grid>
                        <Grid item xs={6} sm={6}>
                          : MALE.
                        </Grid>
                      </Grid>
                    </Typography>
                    <Typography variant="body1" gutterBottom>
                      <Grid container spacing={2}>
                        <Grid item xs={6} sm={6}>
                          EXPECTED SALARY
                        </Grid>
                        <Grid item xs={6} sm={6}>
                          : SINGLE.
                        </Grid>
                      </Grid>
                    </Typography>
                    <Typography variant="body1" gutterBottom>
                      <Grid container spacing={2}>
                        <Grid item xs={6} sm={6}>
                          INTERESTED WORK IN COUNTRY
                        </Grid>
                        <Grid item xs={6} sm={6}>
                          : IMMEDIATE.
                        </Grid>
                      </Grid>
                    </Typography>
                  </Box>
                </Box>

              </Box>
            </td>
          </tbody>

          {/* education */}
          <tbody>

            <td>
              <Box sx={{ fontSize: '16px', fontFamily: 'Arial, sans-serif' }}>
                <Box
                  display='flex'
                  justifyContent='space-between'
                  alignItems='right'
                  sx={{ backgroundColor: '#07519d ', color: 'white', padding: '10px', opacity: 1 }}
                >
                  <Typography variant='h6' gutterBottom>
                    Educational Qualifications
                  </Typography>
                </Box>
              </Box>

              <Box display="flex" flexDirection="row">
                <Box>
                  <td>
                    <List>
                      {educationalQualification?.map((qualification) => (
                        <tbody>
                          <ListItem key={qualification.title}>
                            <ListItemText
                              primary={qualification.title}
                              secondary={qualification.description + " (" + qualification.yearfrom + ", " + qualification.yearto + ")"}
                              className={classes.listItemText}
                            />
                          </ListItem>
                        </tbody>
                      ))}
                    </List>
                  </td>
                </Box>
              </Box>

            </td>


          </tbody>
          {/* professionalQualifications */}
          <tbody>

            <td>
              <Box sx={{ fontSize: '16px', fontFamily: 'Arial, sans-serif' }}>
                <Box
                  display='flex'
                  justifyContent='space-between'
                  alignItems='right'
                  sx={{ backgroundColor: '#07519d ', color: 'white', padding: '10px', opacity: 1 }}
                >
                  <Typography variant='h6' gutterBottom>
                    Professional Qualifications
                  </Typography>
                </Box>
              </Box>

              <Box display="flex" flexDirection="row">
                <Box>
                  <td>
                    <List>
                      {professionalQualifications?.map((qualification) => (
                        <tbody>
                          <ListItem key={qualification.title}>
                            <ListItemText
                              primary={qualification.title}
                              secondary={qualification.description + " (" + qualification.yearfrom + ", " + qualification.yearto + ")"}
                              className={classes.listItemText}
                            />
                          </ListItem>
                        </tbody>
                      ))}
                    </List>
                  </td>
                </Box>
              </Box>

            </td>


          </tbody>
          {/* workExperience */}

          <tbody>

            <td>
              <Box sx={{ fontSize: '16px', fontFamily: 'Arial, sans-serif' }}>
                <Box
                  display='flex'
                  justifyContent='space-between'
                  alignItems='right'
                  sx={{ backgroundColor: '#07519d ', color: 'white', padding: '10px', opacity: 1 }}
                >
                  <Typography variant='h6' gutterBottom>
                    Work Experience
                  </Typography>
                </Box>
              </Box>

              <Box display="flex" flexDirection="row">
                <Box>
                  <List>
                    {workExperience?.map((qualification) => (
                      <tbody>
                        <ListItem key={qualification.title}>
                          <ListItemText
                            primary={qualification.title}
                            secondary={qualification.description + " (" + qualification.yearfrom + ", " + qualification.yearto + ")"}
                            className={classes.listItemText}
                          />
                        </ListItem>
                      </tbody>
                    ))}
                  </List>
                </Box>
              </Box>

            </td>
          </tbody>

          {/* Images */}


        </table>
        <div>
          <div>

            <Document file={selectedFile} onLoadSuccess={onDocumentLoadSuccess} renderTextLayer={{ textContentSource: 'stream' }}>
              {Array.from(new Array(numPages), (_, index) => (
                <Page key={`page_${index + 1}`} pageNumber={index + 1} width={800} />
              ))}
            </Document>

          </div>
        </div>

      </div>
    </>
  );
};

export default UserProfileContainer;
